import { AlertMsgMngrService } from './../msg/alert-msg-mngr.service';
import { userSettings } from './../common/settings';
import { Component } from '@angular/core';
import { MatSliderChange } from '@angular/material/slider';
import { MatSelectChange } from '@angular/material/select';
import { MapMngr } from '../asp/MapMngr';
import { TranslateService } from '@ngx-translate/core';
import * as settings from '../common/settings';
import { HttpClient } from '@angular/common/http';
import * as consts from '../common/consts';
import * as enums from '../common/enums';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { aspMngr } from '../asp/AspMngr';
import { MsgBoxService } from '../msg-boxes/msg-box.service';
import { ProjConstants } from 'src/app/common/projConsts';

@Component({
  selector: 'global-settings',
  templateUrl: './global-settings.component.html',
  styleUrls: ['./global-settings.component.scss']
})
export class GlobalSettingsComponent {

  isShown: boolean = false;

  symbolsSize: number = settings.userSettings.symbolsSize;
  autoSymbolsSize: boolean = settings.userSettings.autoSymbolSize;
  displayUnits: settings.DisplayUnits = settings.userSettings.displayUnits;
  notifications: settings.NotificationSettings = settings.userSettings.notifications;
  selectedLanguage: string = 'en';
  languages: any = [];
  allDisplayUnits = [];

  verString = settings.userSettings.euroVer;

  constructor(private translateService: TranslateService,
    private httpClient: HttpClient,
    protected msgBox: MsgBoxService,
    private alertMsgMngrService: AlertMsgMngrService) {
    this.httpClient.get("../../../assets/languages.json").subscribe(data => { this.languages = data })
    let numDisplayUnits = settings.DisplayUnitsTitles.length;
    for (let i = 0; i < numDisplayUnits; i++)
      this.allDisplayUnits.push({ title: settings.DisplayUnitsTitles[i], id: i });

    this.selectedLanguage = translateService.currentLang; 
  }

  onSymbolsSizeSliderChanged(event: MatSliderChange) {
    settings.userSettings.setSymbolsSize(event.value);
    MapMngr.redrawAllMaps();
  }

  minSymbolsSize() {
    return 0.5;
  }

  maxSymbolsSize() {
    return 2.0;
  }

  onDisplayUnitsSelected(event: MatSelectChange) {
    settings.userSettings.setDisplayUnits(event.value);
    MapMngr.redrawAllMaps();
  }

  setLanguage(event: MatSelectChange) {
    this.selectedLanguage = (event.value);
    this.translateService.use(this.selectedLanguage);
    localStorage.setItem(consts.LOCAL_STORAGE_CURRENT_LANGUAGE, this.selectedLanguage);
    consts.initConstants(new ProjConstants(), this.translateService);
  }

  show() {
    this.isShown = true;
    this.verString = settings.userSettings.euroVer;
  }

  hide() {
    this.isShown = false;
  }

  saveDTMChecked(event: MatCheckboxChange) {
    localStorage.setItem(consts.LOCAL_STORAGE_SHOW_DTM_KEY, JSON.stringify(event.checked));
    localStorage.setItem(consts.LOCAL_STORAGE_HEIGHT_KEY, '');
  }

  autoSizeChange(event: MatCheckboxChange) {
    settings.userSettings.setAutoSymbolSize(this.autoSymbolsSize);
  }

  async resetSystem() {
    // ask for consent :)
    let confirmed = await this.msgBox.showConfirmMsgBox("Are You Sure You Want To Reset Local Data?", "Reset Local Data", "Yes", "No");
    if (!confirmed)
      return;

    // delete all data
    aspMngr.deleteAllObjects();

    // send switch actions to get all the info back
    // AppInjector.get(UserActionService).sendUserAction(new projMsgs.GetSensors());
    // AppInjector.get(UserActionService).sendUserAction(new projMsgs.GetTracks());
    // AppInjector.get(UserActionService).sendUserAction(new projMsgs.GetClsArm());
    // AppInjector.get(UserActionService).sendUserAction(new projMsgs.ClientInit());

  }

  async getAbout() {
    let confirmed = await this.msgBox.showConfirmMsgBox(settings.userSettings.euroVer, "Versions", "OK");
    if (!confirmed)
      return;
  }

  isAdmin() : boolean {
    return settings.userSettings.userPerm == enums.Permission.ADMIN;
  } 

  
  toggleAlerts(){
    userSettings.setNotifications(this.notifications);
    this.alertMsgMngrService.toggleMessageConnection({ alerts: this.notifications.alerts})
  }

  toggleVideoAzimuth(){
    userSettings.setNotifications(this.notifications);
    this.alertMsgMngrService.toggleMessageConnection({ videoAzimuth: this.notifications.videoAzimuth})
  }
  toggleSensorAzimuth(){
    userSettings.setNotifications(this.notifications);
    this.alertMsgMngrService.toggleMessageConnection({ sensorAzimuth: this.notifications.sensorAzimuth})
  }
}
